import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum SubscriptionActionEnum {
	Initialize = 'initialize',
	UpdateData = 'update-data',
	UpdateColumns = 'update-columns',
	ClearData = 'clear-data',
	Deactivate = 'deactivate',
	Activate = 'activate',
	Delete = 'delete',
}

export interface ISubscriptionConfirmationModalData {
	subscriptionId: number | Array<number>;
	element: string;
	action: SubscriptionActionEnum;
}

@Component({
	selector: 'app-subscription-action-confirm-popup',
	templateUrl: './subscription-action-confirm-popup.component.html',
	styleUrls: ['./subscription-action-confirm-popup.component.scss'],
})
export class SubscriptionActionConfirmPopupComponent<
	T extends ISubscriptionConfirmationModalData
> extends DcBaseComponent {
	protected readonly SubscriptionAction = SubscriptionActionEnum;
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		subscriptionId: number | Array<number>;
		action: SubscriptionActionEnum;
		isMultipleElement: boolean;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'subscription-action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.subscriptionId),
			subscriptionId: this.modalData.subscriptionId,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
